module.exports = __webpack_public_path__ + "images/bannerPT-ba23d55c00651ce51b9ffb9f82a61389.png";